import { render, staticRenderFns } from "./custInoundHistory.vue?vue&type=template&id=7681cdc9&scoped=true&"
import script from "./custInoundHistory.vue?vue&type=script&lang=js&"
export * from "./custInoundHistory.vue?vue&type=script&lang=js&"
import style0 from "./custInoundHistory.vue?vue&type=style&index=0&id=7681cdc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7681cdc9",
  null
  
)

export default component.exports